<template>
    <v-row no-gutters>
        <v-col>
            <v-row class="pl-3 pb-1" align="baseline" no-gutters>
                <v-col cols="6" class="title font-weight-bold pb-0">
                    {{ translations.invoice_number }}
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="invoiceNumber"
                        :class="!isEditing ? 'hide-underlines' : ''"
                        :disabled="!isEditing"
                        class="title font-weight-medium mt-0 regular-disabled"
                        label=""
                        dense
                        style="max-width: 250px"
                        single-line
                        :error-messages="invoiceNumberError"
                        :hide-details="!isEditing || (isEditing && !invoiceNumberError)"
                        @input="$emit('update:invoiceNumber', $event)"
                    />
                </v-col>
            </v-row>
            <v-row
                v-if="referenceNumber || isEditing"
                class="pl-3 pb-2"
                align="baseline"
                no-gutters
            >
                <v-col cols="6" class="font-weight-bold">
                    {{ translations.reference_number }}
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="referenceNumber"
                        class="font-weight-bold regular-disabled"
                        label=""
                        single-line
                        dense
                        style="max-width: 250px"
                        :disabled="!isEditing"
                        :class="!isEditing ? 'hide-underlines' : ''"
                        hide-details
                        @input="$emit('update:referenceNumber', $event)"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters class="pl-3 pb-2" align="baseline" justify="start">
                <v-col cols="6" class="pb-0">
                    {{ translations.invoice_date }}
                </v-col>
                <v-col class="pt-0" cols="6">
                    <date-picker
                        :value="invoiceDate"
                        @input="$emit('update:invoiceDate', $event)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="mt-0 regular-disabled"
                                label=""
                                single-line
                                dense
                                readonly
                                style="max-width: 150px"
                                :value="invoiceDate | format_date"
                                :error-messages="invoiceDateError"
                                :disabled="!isEditing"
                                :class="!isEditing ? 'hide-underlines' : ''"
                                :hide-details="!isEditing || (isEditing && !invoiceDateError)"
                                v-on="on"
                            />
                        </template>
                    </date-picker>
                </v-col>
            </v-row>
            <v-row no-gutters class="pl-3 pb-2" align="baseline" justify="start">
                <v-col cols="6" class="pb-0">
                    {{ translations.due_date }}
                </v-col>
                <v-col class="pt-0" cols="6">
                    <date-picker
                        :value="dueDate"
                        @input="$emit('update:dueDate', $event)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="mt-0 regular-disabled"
                                label=""
                                single-line
                                dense
                                readonly
                                hide-details="auto"
                                style="max-width: 150px"
                                :disabled="!isEditing"
                                :value="dueDate | format_date"
                                :error-messages="dueDateError"
                                :class="!isEditing ? 'hide-underlines' : ''"
                                v-on="on"
                            />
                        </template>
                    </date-picker>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>

import AppModule from "@/store/modules/app";

export default {
    name: "InvoiceSettingsFields",
    components: {
    },
    props: {
        isEditing:{
            type: Boolean,
            default: false
        },
        translations:{
            type: Object,
            default: () => {}
        },
        referenceNumber:{
            type: String,
            default: ''
        },
        invoiceNumber:{
            type: String,
            default: ''
        },
        invoiceDate:{
            type: String,
            default: ''
        },
        dueDate:{
            type: String,
            default: ''
        },
        invoiceDateError:{
            type: String,
            default: ''
        },
        dueDateError:{
            type: String,
            default: ''
        },
        invoiceNumberError:{
            type: String,
            default: ''
        },

    },
    setup() {
        const { formatting } = AppModule();
        return {
            formatting
        };
    }
};
</script>

<style scoped lang="scss">
::v-deep .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    padding: 6px 12px 11px;
    max-height: 34px;
}
</style>
